export default __webpack_public_path__ + "static/media/climate2.3b32bd42.jpg";